import { render } from "./list-share-actions.vue?vue&type=template&id=afff81d4&scoped=true&ts=true"
import script from "./list-share-actions.vue?vue&type=script&lang=ts"
export * from "./list-share-actions.vue?vue&type=script&lang=ts"

import "./list-share-actions.vue?vue&type=style&index=0&id=afff81d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afff81d4"]])

export default __exports__